import { useCallback, useEffect, useState } from "react";

type TermlyCategory =
  | "essential"
  | "advertising"
  | "analytics"
  | "performance"
  | "social_networking"
  | "unclassified";

export default function useTermlyConsent(required: TermlyCategory[]) {
  const [granted, setGranted] = useState(false);

  const checkConsent = useCallback(() => {
    const state = (window as any)?.Termly?.getConsentState?.();
    if (!state) {
      return false;
    }

    return required.every(k => Boolean(state[k]));
  }, [required]);

  useEffect(() => {
    setGranted(checkConsent());

    const termly = (window as any).Termly;
    if (termly?.on) {
      const update = () => setGranted(checkConsent());

      termly.on("initialized", update);
      termly.on("consent", update);

      return () => {
        if (termly.off) {
          termly.off("initialized", update);
          termly.off("consent", update);
        }
      };
    }
  }, [checkConsent]);

  return granted;
}
